import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faSearch, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        accountsPayableResult: [],
        accountsReceivableResult: []
    }
    deleteRecords = (id) => {
        Swal.fire({
            title: 'Are you sure to Delete the Record?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Delete',
            denyButtonText: `Cancel`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("financial_movements/delete/" + id)
                    .then((dataResult) => {
                        console.log(dataResult);
                        Swal.fire('Deleted!', dataResult.data.msj, 'success')
                        this.ListarArrayResult(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Canceled', '', 'info')
            }
        })
    };

    ListarArrayResult(page, tab = null) {
        Swal.showLoading();
        let btype = document.getElementById('btype').value;
        let bname = document.getElementById('bname').value;
        if (bname == '') {
            bname = 0;
        }
        if (btype == '') {
            btype = 0;
        }
        authAxios.get("financial_movements/index/" + btype + "/" + bname + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.data.status;
                if (status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (tab === null) {
                    this.setState({
                        accountsPayableResult: dataResult.data.accountsPayable.data,
                        accountsReceivableResult: dataResult.data.accountsReceivable.data,
                        pageAP: dataResult.data.accountsPayable.total,
                        pageAR: dataResult.data.accountsReceivable.total,
                        lastAP: dataResult.data.accountsPayable.last_page,
                        lastAR: dataResult.data.accountsReceivable.last_page,
                        currentAP: dataResult.data.accountsPayable.current_page,
                        currentAR: dataResult.data.accountsReceivable.current_page
                    });
                } else if (tab === 'accountsPayable') {
                    this.setState({
                        accountsPayableResult: dataResult.data.accountsPayable,
                        pageAP: dataResult.data.accountsPayable.total,
                        lastAP: dataResult.data.accountsPayable.last_page,
                        currentAP: dataResult.data.accountsPayable.current_page
                    });
                } else if (tab === 'accountsReceivable') {
                    this.setState({
                        accountsReceivableResult: dataResult.data.accountsReceivable,
                        pageAR: dataResult.data.accountsReceivable.total,
                        lastAR: dataResult.data.accountsReceivable.last_page,
                        currentAR: dataResult.data.accountsReceivable.current_page
                    });
                }
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarArrayResult(1);
    }
    render() {
        const {
            load,
            accountsPayableResult,
            accountsReceivableResult,
            pageAP,
            pageAR,
            lastAP,
            lastAR,
            currentAP,
            currentAR
        } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br/>
                    <div className="card">
                        <div className="card-header">
                            &nbsp;
                        </div>
                        <div className="card-body">
                            <h4>Assets & Liabilities</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-2">
                                    <select name="btype" id="btype"
                                        className={"form-select form-select-sm"}>
                                        <option value="">CHOOSE...</option>
                                        <option value="1">BY CLIENT</option>
                                        <option value="2">BY INVOICE</option>
                                    </select>
                                </div>
                                <div className="col-xl-4">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bname" name="bname" placeholder="Search for Client Name" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarArrayResult(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filter</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-xl-12">
                                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" id="pills-accounts_payable-tab" data-bs-toggle="pill" data-bs-target="#pills-accounts_payable" type="button" role="tab" aria-controls="pills-accounts_payable" aria-selected="true">Accounts Payables</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="pills-accounts_receivable-tab" data-bs-toggle="pill" data-bs-target="#pills-accounts_receivable" type="button" role="tab" aria-controls="pills-accounts_receivable" aria-selected="false">Accounts Receivable</button>
                                        </li>
                                    </ul>
                                    <div class="tab-content" id="pills-tabContent">
                                        <div class="tab-pane fade show active" id="pills-accounts_payable" role="tabpanel" aria-labelledby="pills-accounts_payable-tab" tabindex="0">
                                            <div className="card">
                                                <div className="card-header text-center">
                                                    <b>ACCOUNTS PAYABLES</b>
                                                </div>
                                                <div className="card-body">
                                                    <table className="table table-hover table-condensed table-sm">
                                                        <thead className="thead-inverse">
                                                            <tr>
                                                                <th className="align-middle">INVOICE</th>
                                                                <th className="align-middle">SUPPLIER</th>
                                                                <th className="align-middle">AMOUNT</th>
                                                                <th className="align-middle">INVOICE DATE</th>
                                                                <th className="align-middle">STATUS</th>
                                                                {/* <th className="align-middle">ACTION</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {load}
                                                            {
                                                                accountsPayableResult.map((itemAccountsPayableResult) => (
                                                                    <tr key={itemAccountsPayableResult.ID_ACCOUNT}>
                                                                        <td>{itemAccountsPayableResult.INVOICE}</td>
                                                                        <td>{itemAccountsPayableResult.NAME}</td>
                                                                        <td><b>$ </b>{currencyFormat(itemAccountsPayableResult.AMOUNT)}</td>
                                                                        <td>{itemAccountsPayableResult.DUE_DATE}</td>
                                                                        {
                                                                            (() => {
                                                                                switch (itemAccountsPayableResult.AP_STATUS) {
                                                                                    case 1:
                                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#00539B' }} className="badge">IN PROCESS</span></td>)
                                                                                    case 2:
                                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#ADAEAF' }} className="badge">PENDING</span></td>)
                                                                                    case 3:
                                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">PAID</span></td>)
                                                                                }
                                                                            })()
                                                                        }
                                                                        {/* <td>
                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary btn-sm"
                                                                                    data-bs-toggle='modal'
                                                                                    data-bs-target="#InfoInvoicesModal"
                                                                                    slot='end'
                                                                                    onClick={() => {
                                                                                        this.infoInvoices(itemAccountsPayableResult.ID_INVOICE)
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faSearch} />
                                                                                </button>
                                                                            </div>
                                                                        </td> */}
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                    <br />
                                                    <nav aria-label="Page navigation example">
                                                        <ul className="pagination">
                                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(1, 'accountsPayable')}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(currentAP - 1, 'accountsPayable')}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                            {(() => {
                                                                let p = [];
                                                                p.push(<li className="page-item" key={currentAP}><a className="page-link" href="#" onClick={() => this.ListarArrayResult(currentAP, 'accountsPayable')}>{currentAP}</a></li>);
                                                                return p;
                                                            })()}
                                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(currentAP + 1, 'accountsPayable')}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(lastAP, 'accountsPayable')}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                                <div className="card-footer text-muted">
                                                    <b>Page</b> <span className="badge bg-primary">{currentAP}</span> <b>of</b> <span className="badge bg-primary">{lastAP}</span> | <b>Records</b> <span className="badge bg-success">{pageAP}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="pills-accounts_receivable" role="tabpanel" aria-labelledby="pills-accounts_receivable-tab" tabindex="0">
                                        <div className="card">
                                                <div className="card-header text-center">
                                                    <b>ACCOUNTS RECEIVABLE</b>
                                                </div>
                                                <div className="card-body">
                                                    <table className="table table-hover table-condensed table-sm">
                                                        <thead className="thead-inverse">
                                                            <tr>
                                                                <th className="align-middle">INVOICE</th>
                                                                <th className="align-middle">CUSTOMER</th>
                                                                <th className="align-middle">AMOUNT</th>
                                                                <th className="align-middle">INVOICE DATE</th>
                                                                <th className="align-middle">STATUS</th>
                                                                {/* <th className="align-middle">ACTION</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {load}
                                                            {
                                                                accountsReceivableResult.map((itemAccountsReceivableResult) => (
                                                                    <tr key={itemAccountsReceivableResult.ID_ACCOUNT}>
                                                                        <td>{itemAccountsReceivableResult.INVOICE}</td>
                                                                        <td>{itemAccountsReceivableResult.NAME}</td>
                                                                        <td><b>$ </b>{currencyFormat(itemAccountsReceivableResult.AMOUNT)}</td>
                                                                        <td>{itemAccountsReceivableResult.DUE_DATE}</td>
                                                                        {
                                                                            (() => {
                                                                                switch (itemAccountsReceivableResult.AR_STATUS) {
                                                                                    case 1:
                                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">PAID</span></td>)
                                                                                    case 2:
                                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#ADAEAF' }} className="badge">PENDING</span></td>)
                                                                                    case 3:
                                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">FAILED</span></td>)
                                                                                }
                                                                            })()
                                                                        }
                                                                        {/* <td>
                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary btn-sm"
                                                                                    data-bs-toggle='modal'
                                                                                    data-bs-target="#InfoInvoicesModal"
                                                                                    slot='end'
                                                                                    onClick={() => {
                                                                                        this.infoInvoices(itemAccountsReceivableResult.ID_INVOICE)
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faSearch} />
                                                                                </button>
                                                                            </div>
                                                                        </td> */}
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                    <br />
                                                    <nav aria-label="Page navigation example">
                                                        <ul className="pagination">
                                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(1, 'accountsReceivable')}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(currentAR - 1, 'accountsReceivable')}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                            {(() => {
                                                                let p = [];
                                                                p.push(<li className="page-item" key={currentAR}><a className="page-link" href="#" onClick={() => this.ListarArrayResult(currentAR, 'accountsReceivable')}>{currentAR}</a></li>);
                                                                return p;
                                                            })()}
                                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(currentAR + 1, 'accountsReceivable')}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(lastAR)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                                <div className="card-footer text-muted">
                                                    <b>Page</b> <span className="badge bg-primary">{currentAR}</span> <b>of</b> <span className="badge bg-primary">{lastAR}</span> | <b>Records</b> <span className="badge bg-success">{pageAR}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer text-muted">
                            &nbsp;
                            {/* <b>Page</b> <span className="badge bg-primary">{current}</span> <b>of</b> <span className="badge bg-primary">{last}</span> | <b>Records</b> <span className="badge bg-success">{page}</span> */}
                        </div>
                    </div>
                </div>
                {/* Modals */}
                <div className="modal fade" id="InfoInvoicesModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="InfoInvoicesModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div class="modal-header">
                                <div className='col-11'>
                                    <h4 className="modal-title w-100 text-center" id="">Invoice</h4>
                                </div>
                                <div className='col-1'>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;